import { render, staticRenderFns } from "./SvgTree.vue?vue&type=template&id=6fad38ce"
import script from "./SvgTree.vue?vue&type=script&lang=js"
export * from "./SvgTree.vue?vue&type=script&lang=js"
import style0 from "./SvgTree.vue?vue&type=style&index=0&id=6fad38ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports